(function () {

    "use strict";

    console.log("🚀 Merge Engine Started");

    function mergeReviews() {

        if (!window.TRUSTSHOP_DATA) {

            console.log("Waiting for TRUSTSHOP_DATA...");

            setTimeout(mergeReviews, 500);

            return;

        }

        if (!window.GENERATED_REVIEWS) {

            console.log("Waiting for GENERATED_REVIEWS...");

            setTimeout(mergeReviews, 500);

            return;

        }

        const trustshopReviews =
            window.TRUSTSHOP_DATA.reviews || [];

        const generatedReviews =
            window.GENERATED_REVIEWS || [];

        window.MERGED_REVIEWS = [

            ...trustshopReviews,

            ...generatedReviews

        ];

        console.log("✅ MERGED_REVIEWS CREATED");

        console.table(window.MERGED_REVIEWS);

        console.log(
            "Total Reviews:",
            window.MERGED_REVIEWS.length
        );

    }

    mergeReviews();

})();